import React, { useMemo, useState } from "react";

import axios, { AxiosError, AxiosResponse } from "axios";
import { UpgradePlanModal } from "components/modals/Upgrade-plan-modal/UpgradePlanModal";
// import qs from "qs";

import i18n from "i18n";
import { useDispatch } from "store";
import { AuthAction, ViewAction } from "store/actions";
import { ApiServiceError, ApiServiceParams, useApi } from "store/services";
import { AltiusErrors } from "store/types";
import { getDomain, getProtocol } from "utils/auth";

import { ApiContext } from "./ApiContext";

interface IApiProviderProps {
  children: React.ReactNode;
}

const domain = getDomain();
const protocol = getProtocol();

export const ApiProvider = ({ children }: IApiProviderProps): JSX.Element => {
  const dispatch = useDispatch(); // Technical issue, should be found another solution

  // Upgrade Plan Modal state
  const [isOpen, setIsOpen] = useState(false);

  const resInterceptor = useMemo(
    () => ({
      onFulfilled: (value: AxiosResponse) => value,
      onRejected: (error: AxiosError<AltiusErrors>) => {
        if (axios.isCancel(error)) {
          return new Promise(() => {});
        }

        const errorInstance = new ApiServiceError(error);

        if (error.response?.status === 401) {
          dispatch({
            type: AuthAction.RemoveToken,
            payload: null
          });
        }
        if (error.response?.status === 402) {
          // Freemium error - Show upgrade modal
          setIsOpen(true);
        }
        if (error.response?.status === 409) {
          dispatch({
            type: ViewAction.SetError409,
            payload: "You are logged in from another device"
          });
        }

        return Promise.reject(errorInstance);
      }
    }),
    []
  );

  const altiusApiConfig: ApiServiceParams = useMemo(() => {
    const config: ApiServiceParams = {
      baseURL: `${protocol}${domain}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "Accept-Language": i18n.language
      },
      reqIntercept: {
        onFulfilled: (config) => {
          config.headers["Accept-Language"] = i18n.language;
          return config;
        }
      }
      // Temporary disable serializer
      // paramsSerializer: qs.stringify
      // paramsSerializer: {
      //   encode: (params) => qs.stringify(params, { arrayFormat: "repeat" })
      // }
    };

    config.resIntercept = resInterceptor;
    // TODO: Do we still need this?
    // config.reqIntercept = reqInterceptor("accesstoken");
    return config;
  }, [domain, resInterceptor]);

  const altiusApi = useApi(altiusApiConfig);
  return (
    <ApiContext.Provider value={{ altiusApi }}>
      {children}
      <UpgradePlanModal isOpen={isOpen} onClose={() => setIsOpen(false)} />
    </ApiContext.Provider>
  );
};

ApiProvider.displayName = "ApiProvider";
